// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-02402aa4]{border-collapse:collapse;font-size:var(--font-size-0);width:100%}tbody th[data-v-02402aa4]{font-weight:400;text-align:left}.summary-table[data-v-02402aa4]{margin-top:var(--size-3)}td.text-right[data-v-02402aa4]{text-align:right}.row-with-separator[data-v-02402aa4]{border-top:1px solid var(--swi-ui-border-color)}.summary-table__details[data-v-02402aa4]{color:var(--color-primary)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
